import React from 'react'
import { IRadioProps, TVal } from '../Input.types'
import css from '../Input.module.scss'

export const Radio = <T extends TVal>({
  className,
  checked,
  disabled,
  label,
  value,
  onSelect,
  ...passingProps
}: IRadioProps<T>) => (
  <label
    className={`${css.radioLabel}  ${checked ? css.isActive : ''} ${
      disabled ? css.isDisabled : ''
    } ${className}`}
  >
    <input
      {...passingProps}
      className={css.radioInput}
      type="radio"
      checked={checked}
      disabled={disabled}
      onChange={() => onSelect(value)}
    />
    <span className={css.radioControl} />
    {label}
  </label>
)
